import { useSyncExternalStore } from "react";
import {
  navigate,
  useBrowserLocation,
  type BrowserLocationHook,
} from "wouter/use-browser-location";
import {
  allowLiveCallNavigation,
  liveCallHeldPath,
  subscribeLiveCallLocation,
} from "@/lib/liveCallLocation";

/**
 * Переход роутера: во время звонка на другой адрес — только после «Уйти».
 * Одна функция на всё приложение, а не новая на каждый рендер: её держат
 * зависимости эффектов (DashboardLayout).
 */
const guardedNavigate: typeof navigate = (to, options) => {
  if (
    !allowLiveCallNavigation(to, window.location.href, text =>
      window.confirm(text)
    )
  )
    return;
  navigate(to, options);
};

/**
 * Адрес для роутера: как у wouter по умолчанию, но пока идёт звонок — адрес
 * комнаты (lib/liveCallLocation). Так «Назад» в браузере или переход по ссылке
 * не снимают комнату, пока человек не подтвердил уход.
 */
export const useGuardedLocation: BrowserLocationHook = options => {
  const [path] = useBrowserLocation(options);
  const held = useSyncExternalStore(
    subscribeLiveCallLocation,
    liveCallHeldPath,
    () => null
  );
  return [held ?? path, guardedNavigate];
};
